import { Map } from 'immutable';
import getIn from 'lodash/get';

import * as PaymentsConstants from '../constants';
import * as D from '../deps';

const INITIAL_STATE = Map({
  [PaymentsConstants.ReducerKeys.PP_VENDOR_SKU]: '',
  [PaymentsConstants.ReducerKeys.PP_PRODUCT_ID]: '',
  [PaymentsConstants.ReducerKeys.PP_TIER]: '',
  [PaymentsConstants.ReducerKeys.PP_DISCOUNT_TYPE]: '',
  [PaymentsConstants.ReducerKeys.PP_DURATION_TYPE]: '',
  [PaymentsConstants.ReducerKeys.PP_SPECIAL_OFFER_CODE]: '',
});

export default D.createReducer(INITIAL_STATE, {
  [D.Constants.Api.ApiActions.PREPARE_TO_ACQUIRE_PAYPAL_PRODUCT_SUCCESS]: storePaypalParams,
  [D.Constants.Api.ApiActions.ACQUIRE_PRODUCT_SUCCESS]: clearPaypalParams,
  [D.Constants.Api.ApiActions.LOGOUT_SUCCESS]: clearPaypalParams,
});

function storePaypalParams(state, action) {
  return state.merge({
    [PaymentsConstants.ReducerKeys.PP_VENDOR_SKU]: getIn(action, 'params.content.vendorSku', ''),
    [PaymentsConstants.ReducerKeys.PP_PRODUCT_ID]: getIn(
      action,
      'params.content.backingProductIdentifier',
      '',
    ),
    [PaymentsConstants.ReducerKeys.PP_TIER]: getIn(action, 'params.content.tierName', ''),
    [PaymentsConstants.ReducerKeys.PP_DISCOUNT_TYPE]: getIn(
      action,
      'params.content.discountType',
      '',
    ),
    [PaymentsConstants.ReducerKeys.PP_DURATION_TYPE]: getIn(
      action,
      'params.content.durationType',
      '',
    ),
    [PaymentsConstants.ReducerKeys.PP_SPECIAL_OFFER_CODE]: getIn(
      action,
      'params.content.specialOfferToken',
      '',
    ),
  });
}

function clearPaypalParams() {
  return INITIAL_STATE;
}
